import React, { useContext, useEffect, useRef } from 'react';
import { useParams } from 'react-router-dom';

import { ConfigContext, UserDataContext } from '../../App';

export const FastSpringForm = ({ buyUrl, fastSpringId }) => {
  const { fastSpringUrl } = useContext(ConfigContext) ?? {};
  const { profile = {} } = useContext(UserDataContext) ?? {};
  const { id } = useParams();
  /**@type { React.MutableRefObject<HTMLFormElement | null>} */
  const formRef = useRef(null);

  //@TODO: need to know why fujifilm is hard coded
  const fastSpringFormBuyUrl = buyUrl ? '/' + buyUrl : '/com_fujifilm_FUJIFILMTetherShootingPluginforWindows';
  const isAdusLocations = ['CA', 'GL', 'PM', 'US', 'VI'].includes(profile.location);
  const fastSpringFormSource = isAdusLocations ? 'adus' : 'adir';
  const fastSpringFormTags = 'oaecloud,uxp,' + id;

  useEffect(() => {
    if (fastSpringId && id) {
      formRef.current?.requestSubmit();
      sessionStorage.setItem('redirected-to-fs', id);
    }
  }, [fastSpringId, id]);

  return (
    <form
      style={{ display: 'none' }}
      method="POST"
      action={fastSpringUrl ?? process.env.FAST_SPRING_URL}
      id="fast-spring-frm"
      data-testid="fast-spring-form"
      ref={formRef}
    >
      <input type="hidden" name="tags" id="fast-spring-frm-ele-tags" value={fastSpringFormTags} />
      <input type="hidden" name="source" id="fast-spring-frm-ele-source" value={fastSpringFormSource} />
      <input type="hidden" name="operation" id="fast-spring-frm-ele-operation" value="create" />
      <input type="hidden" name="product_1_path" id="fast-spring-frm-ele-product-1-path" value={fastSpringFormBuyUrl} />
      <input type="hidden" name="product_1_quantity" id="fast-spring-frm-ele-product-1-quantity" value="1" />
      <input type="hidden" name="contact_fname" id="fast-spring-frm-ele-contact-fname" value={profile.first_name} />
      <input type="hidden" name="contact_lname" id="fast-spring-frm-ele-contact-lname" value={profile.last_name} />
      <input type="hidden" name="contact_email" id="fast-spring-frm-ele-contact-email" value={profile.email} />
      <input type="hidden" name="identifier" id="fast-spring-frm-ele-identifier" value={fastSpringId} />
      <input type="hidden" name="referrer" id="fast-spring-frm-ele-referrer" value={fastSpringId} />
      <input type="hidden" name="destination" id="fast-spring-frm-ele-designation" value="checkout" />
      <input type="hidden" name="catalog" id="fast-spring-frm-ele-catalog" value={window.location.href} />
    </form>
  );
};
